module.exports = __webpack_public_path__ + "img/service-openness.929d34e8.png";